import { TagInputStoreSlice } from './types';
import { reduxKey } from './constants';

function getState(state: any): TagInputStoreSlice {
  if (!state[reduxKey]) {
    return {} as any;
  }
  return state[reduxKey];
}

export const getSearchResults = state => getState(state).tagSearchResults;
export const getSearchRequestStatus = state =>
  getState(state).searchRequestStatus;
